<div data-cid="buy-confirmation-modal" class="relative text-center">
  <div
    class="flex min-h-96 flex-col gap-4 rounded-2xl bg-brand-secondary-pure px-4 pb-6 pt-8 text-white"
  >
    <img
      src="assets/images/other-shopping-cart.webp"
      class="mx-auto my-3 h-24 w-28"
      alt="Carrinho de compras"
    />

    <h2 class="text-xl font-semibold">Tudo certo!</h2>

    @switch (status()) {
      @case ('counting') {
        <p class="text-base">
          Seu pagamento está quase pronto! <br />
          Redirecionando em
          <strong class="font-semibold">{{ countdown() }} segundos</strong>...
        </p>
      }
      @case ('redirecting') {
        <p class="animate-pulse text-base">
          Estamos conectando você à página segura de pagamento...
        </p>
      }
      @case ('redirected') {
        <p class="text-base">
          Redirecionamento realizado! Caso não tenha sido direcionado, clique em
          <strong class="font-semibold">Ir para o pagamento agora</strong>.
        </p>
      }
      @case ('blocked') {
        <p class="text-base text-feedback-helper-light">
          ⚠️ Redirecionamento automático falhou. <br />
          Clique em
          <strong class="font-semibold">Ir para o pagamento agora</strong> para
          continuar.
        </p>
      }
    }

    <p class="text-base">
      Todas as informações referentes à compra serão encaminhadas no e-mail
      informado.
    </p>

    <div
      class="mx-auto mt-10 flex w-full max-w-xs flex-1 flex-col items-end gap-2"
    >
      <button
        class="h-10 w-full whitespace-nowrap rounded-3xl bg-neutral-hight-pure px-3 py-2 text-center text-sm font-semibold text-brand-primary-pure shadow-sm transition-all duration-150 focus-visible:ring-neutral-low-light enabled:hover:bg-neutral-hight-medium enabled:hover:text-brand-primary-dark disabled:cursor-not-allowed disabled:bg-neutral-hight-medium disabled:text-neutral-low-light"
        (click)="attemptRedirect()"
        [disabled]="status() === 'redirecting'"
      >
        Ir para o pagamento agora
      </button>

      <button
        class="h-10 w-full whitespace-nowrap rounded-3xl border border-neutral-hight-pure bg-transparent px-3 py-2 text-center text-sm font-semibold text-neutral-hight-pure shadow-sm transition-all duration-150 hover:border-neutral-hight-medium hover:text-neutral-hight-medium"
        (click)="handleClose()"
      >
        @if (status() === 'redirected' || status() === 'blocked') {
          Fechar
        } @else {
          Cancelar
        }
      </button>
    </div>
  </div>
</div>
